module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Self Storage")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouses,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "City"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "State"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zipCode",
      "label": "Zip Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getWarehousesById(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteWarehouses(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": function($event) {}
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add warehouse",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseForm",
    attrs: {
      "model": _vm.warehouseForm,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.address),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "address", $$v)
      },
      expression: "warehouseForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.city),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "city", $$v)
      },
      expression: "warehouseForm.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.state),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "state", $$v)
      },
      expression: "warehouseForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "zipCode", $$v)
      },
      expression: "warehouseForm.zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit warehouse",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editWarehouseObj",
    attrs: {
      "model": _vm.editWarehouseObj,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.state),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "state", $$v)
      },
      expression: "editWarehouseObj.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.city),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "city", $$v)
      },
      expression: "editWarehouseObj.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.address),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "address", $$v)
      },
      expression: "editWarehouseObj.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "zipCode", $$v)
      },
      expression: "editWarehouseObj.zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-deccf5f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nurse/warehouse.vue
// module id = 853
// module chunks = 1